// src/pages/GetQuote.jsx
import React, { useState } from "react";
import { FileText, Mail, Phone, Briefcase } from "lucide-react";
import { toast } from 'react-toastify';


import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase1"; // your initialized Firestore

const GetQuote = () => {

   const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
    company: "",
    service: "",
    projectDetails: "",
    createdAt: serverTimestamp(),

    // timestamp: new Date(),
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
  
      setFormData({ ...formData, [name]: value });
    
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await addDoc(collection(db, "FITQuote"), {
        ...formData,
        // timestamp: serverTimestamp(),

      });
      // alert("Quote submitted successfully!");
          toast.success("Quote submitted successfully!"); // ✅ success toast

      setFormData({
        fullName: "",
        email: "",
        phone: "",
        company: "",
        service: "",
        projectDetails: "",
      });
    } catch (error) {
      console.error("Error adding document: ", error);
      alert("Failed to submit quote.");
    }
  };


  return (
    <>
          <title>Request a Quote - Focus Inspection Technology</title>

      {/* Write a unique meta description for the Get a Quote page */}
      <meta
        name="description"
        content="Request a free, no-obligation quote for our professional NDT inspection, certification, or training services."
      />
<div className="w-full bg-gray-50">
  {/* Hero Section */}
  <section className="relative w-full h-80 flex items-center justify-center mb-16 overflow-hidden">
    <div className="absolute inset-0 bg-gradient-to-r from-blue-900 via-indigo-800 to-blue-700"></div>

    {/* Pattern Overlay */}
    <svg
      className="absolute inset-0 w-full h-full opacity-20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <pattern
          id="dotPattern"
          width="40"
          height="40"
          patternUnits="userSpaceOnUse"
        >
          <circle cx="2" cy="2" r="2" fill="white" />
        </pattern>
      </defs>
      <rect width="100%" height="100%" fill="url(#dotPattern)" />
    </svg>

    <div className="relative max-w-7xl mx-auto px-6 lg:px-8 text-center">
      <h1 className="text-4xl md:text-5xl font-extrabold text-white drop-shadow-lg">
        Get a Quote
      </h1>
      <p className="text-lg md:text-xl max-w-2xl mx-auto text-white">
        Share your requirements and receive a tailored quote for our inspection
        services.
      </p>
    </div>
  </section>

  {/* Quote Section */}
  <section className="max-w-6xl mx-auto px-6 lg:px-8 pb-20 grid md:grid-cols-2 gap-10">
      {/* Form */}
      <div className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 p-10 rounded-2xl shadow-xl text-white">
        <h2 className="text-3xl font-bold mb-6 border-b border-gray-700 pb-3">
          Request Your Quote
        </h2>
        <form className="space-y-5" onSubmit={handleSubmit}>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            <input
              type="text"
              name="fullName"
              value={formData.fullName}
              onChange={handleChange}
              placeholder="Full Name"
              className="w-full px-4 py-3 rounded-lg text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-600 transition"
            />
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Email Address"
              className="w-full px-4 py-3 rounded-lg text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-600 transition"
            />
            <input
              type="tel"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              placeholder="Phone Number"
              className="w-full px-4 py-3 rounded-lg text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-600 transition"
            />
            <input
              type="text"
              name="company"
              value={formData.company}
              onChange={handleChange}
              placeholder="Company / Organization"
              className="w-full px-4 py-3 rounded-lg text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-600 transition"
            />
          </div>

          <select
            name="service"
            value={formData.service}
            onChange={handleChange}
            className="w-full px-4 py-3 rounded-lg text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-600 transition"
          >
            <option value="">Select Service Required</option>
            <option value="PAUT">PAUT</option>
            <option value="TOFD">TOFD</option>
            <option value="Ultrasonic Testing (UT)">Ultrasonic Testing (UT)</option>
            <option value="Magnetic Particle Testing (MPT)">Magnetic Particle Testing (MPT)</option>
            <option value="Liquid Penetrant Testing (LPT)">Liquid Penetrant Testing (LPT)</option>
            <option value="Other / Custom">Other / Custom</option>
          </select>

          <textarea
            name="projectDetails"
            value={formData.projectDetails}
            onChange={handleChange}
            placeholder="Project Details / Requirements"
            rows="5"
            className="w-full px-4 py-3 rounded-lg text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-600 transition"
          />

          {/* File Upload */}
          {/* <div className="border-2 border-dashed border-gray-500 rounded-lg p-6 text-center hover:border-blue-600 transition">
            <p className="mb-2">Attach Specification / Drawing (optional)</p>
            <input
              type="file"
              name="file"
              onChange={handleChange}
              className="block mx-auto text-sm"
            />
          </div> */}

          <button
            type="submit"
            className="w-full bg-blue-700 hover:bg-blue-800 transition px-6 py-3 rounded-lg font-semibold"
          >
            Submit Request
          </button>
        </form>
      </div>

      {/* Info / Why Choose Us */}
      <div className="flex flex-col justify-center space-y-8">
        <div>
          <h3 className="text-2xl font-bold text-gray-900 mb-3">
            Why Request a Quote?
          </h3>
          <p className="text-gray-700 leading-relaxed">
            Our team provides tailored pricing for each project based on your
            service requirements, location, and scale of inspection. No hidden
            costs — only clear, transparent estimates.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
          <div className="p-5 rounded-xl border border-gray-200 bg-white shadow-sm hover:shadow-md transition">
            <h4 className="text-lg font-semibold text-blue-700">
              Customized Solutions
            </h4>
            <p className="text-sm text-gray-600">
              Every project is unique, and so are our inspection strategies.
            </p>
          </div>
          <div className="p-5 rounded-xl border border-gray-200 bg-white shadow-sm hover:shadow-md transition">
            <h4 className="text-lg font-semibold text-blue-700">Quick Response</h4>
            <p className="text-sm text-gray-600">
              Receive estimates within 24–48 hours after submitting details.
            </p>
          </div>
        </div>
      </div>
    </section>
</div>
</>

  );
};

export default GetQuote;
